module.exports = __webpack_public_path__ + "img/arrowblack-right.ee36678.svg";